export const pictureIsYearbookPose = (picture, pictureSet) => {
    var _a;
    return !!((_a = pictureSet.yearbookPoses) === null || _a === void 0 ? void 0 : _a.find((syp) => syp.pictureClientRef === picture.clientRef));
};
export const pictureIsYearbookPoseForJobYearbookPose = (picture, pictureSet, jobYearbookPose) => {
    var _a;
    return !!((_a = pictureSet.yearbookPoses) === null || _a === void 0 ? void 0 : _a.find((syp) => syp.pictureClientRef === picture.clientRef &&
        syp.jobYearbookPoseUuid === jobYearbookPose.uuid));
};
export const getJobYearbookPoseByPictureSet = (pictureSet, jobYearbookPose) => {
    var _a;
    if (!pictureSet.yearbookPoses) {
        return null;
    }
    const yearbookPosePicture = pictureSet.yearbookPoses.find((yp) => yp.jobYearbookPoseUuid === jobYearbookPose.uuid);
    if (!yearbookPosePicture) {
        return null;
    }
    return ((_a = pictureSet.pictures.find((p) => p.clientRef === yearbookPosePicture.pictureClientRef)) !== null && _a !== void 0 ? _a : null);
};
